<template>
  <div class="has-hero">
    <div
      id="background-wrapper"
      class="iowa-spring-background"
      data-stellar-background-ratio="0.1"
    >
      <div id="navigation" class="wrapper">
        <!--Hidden Header Region-->
        <div class="header-hidden collapse">
          <div class="header-hidden-inner container">
            <div class="row">
              <div class="col-md-3">
                <h3>About Us</h3>
                <p>
                  Iowa Spring provides a quality product, when you need it, at a
                  competitive price.
                </p>
                <router-link :to="{ name: 'AboutUsPage' }" class="btn btn-more">
                  <i class="fa fa-plus"></i> Learn more
                </router-link>
              </div>
              <div class="col-md-3">
                <h3>Contact Us</h3>
                <address>
                  <strong>Iowa Spring Manufacturing</strong>
                  <abbr title="Address">
                    <i class="fa fa-pushpin"></i>
                  </abbr>
                  PO Box 130, 2112 Greene Street, Adel, Iowa 50003
                  <br />
                  <abbr title="Phone">
                    <i class="fa fa-phone"></i>
                  </abbr>
                  1-800-622-2203
                  <br />
                  <abbr title="Email">
                    <i class="fa fa-envelope-alt"></i>
                  </abbr>
                  support@iowaspring.com
                </address>
              </div>
            </div>
          </div>
        </div>
        <div class="header">
          <div class="header-inner container">
            <div class="row">
              <div class="col-md-4">
                <router-link to="/" class="navbar-brand" title="Home">
                  <h1 class="hidden">
                    <img
                      src="../../assets/img/iowa-spring-logo.svg"
                      alt="Iowa Spring Logo"
                    />
                  </h1>
                </router-link>
              </div>
              <div class="col-md-8">
                <ul class="list-inline user-menu pull-right">
                  <li class="hidden-xs">
                    <a
                      class="btn btn-transparent"
                      role="button"
                      href="/static/iso-9001-2015-certificate.pdf"
                      target="_blank"
                      >ISO 9001:2015 Certified</a
                    >
                  </li>
                  <li class="hidden-xs">
                    <a
                      class="btn btn-primary scroll-bottom"
                      role="button"
                      href="#bottom"
                    >
                      <i
                        class="fa fa-envelope-o"
                        aria-hidden="true"
                        style="padding-right: 4px"
                      ></i>
                      Contact Us
                    </a>
                  </li>
                  <li>
                    <a
                      class="btn btn-primary"
                      role="button"
                      href="mailto:jobs@iowaspring.com"
                      target="_blank"
                    >
                      Apply Now
                      <i
                        class="fa fa-chevron-circle-right"
                        aria-hidden="true"
                        style="padding-left: 4px"
                      ></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="navbar navbar-default">
            <button
              type="button"
              class="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target=".navbar-collapse"
              aria-expanded="false"
            >
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <div
              class="
                navbar-text
                social-media social-media-inline
                pull-right
                hidden
              "
            >
              <a href="#">
                <i class="fa fa-twitter"></i>
              </a>
              <a href="#">
                <i class="fa fa-facebook"></i>
              </a>
              <a href="#">
                <i class="fa fa-linkedin"></i>
              </a>
              <a href="#">
                <i class="fa fa-google-plus"></i>
              </a>
            </div>
            <div class="navbar-collapse collapse">
              <ul class="nav navbar-nav" id="main-menu">
                <li class="icon-link home-link">
                  <router-link to="/">
                    <i class="fa fa-home"></i>
                  </router-link>
                </li>
                <li class="dropdown">
                  <a
                    href="#"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    :class="{ active: subIsActive('/mechanical') }"
                    >Mechanical
                    <b class="caret"></b>
                  </a>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link
                        :to="{ name: 'Compression' }"
                        tabindex="-1"
                        class="menu-item"
                        >Compression Springs
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'Extension' }"
                        tabindex="-1"
                        class="menu-item"
                        >Extension Springs
                      </router-link>
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'Torsion' }"
                        tabindex="-1"
                        class="menu-item"
                        >Torsion Springs
                      </router-link>
                    </li>
                  </ul>
                </li>
                <li>
                  <router-link :to="{ name: 'HarrowTineSprings' }"
                    >Harrow Tine</router-link
                  >
                </li>
                <li class="dropdown dropdown-mm">
                  <a
                    href="#"
                    class="dropdown-toggle"
                    data-toggle="dropdown"
                    :class="{ active: subIsActive('/garage-door-springs') }"
                    >Garage Door
                    <b class="caret"></b>
                  </a>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link
                        :to="{ name: 'GarageDoorSpringsTorsion' }"
                        tabindex="-1"
                        class="menu-item"
                        >Garage Door Torsion Springs</router-link
                      >
                    </li>
                    <li>
                      <router-link
                        :to="{ name: 'GarageDoorSpringsExtension' }"
                        tabindex="-1"
                        class="menu-item"
                        >Garage Door Extension Springs</router-link
                      >
                    </li>
                  </ul>
                </li>
                <li>
                  <router-link :to="{ name: 'AboutUsPage' }"
                    >About Us</router-link
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="hero" id="highlighted" v-if="this.$route.name === 'HomePage'">
        <div class="inner">
          <div id="highlighted-slider" class="container">
            <div
              class="item-slider"
              data-toggle="owlcarousel"
              data-owlcarousel-settings='{"singleItem":true, "navigation":true, "transitionStyle":"fadeUp"}'
            >
              <div class="item">
                <div class="row reset-margin">
                  <div class="col-md-6 item-caption">
                    <h2 class="h1 text-weight-light">
                      We are
                      <span class="text-primary heavy">Iowa Spring</span>
                    </h2>
                    <h4>
                      Mechanical, Agricultural and Overhead Garage Door Springs
                    </h4>
                    <p>
                      Since 1977, Iowa Spring has specialized in manufacturing
                      and delivering of springs out of the Midwest. We
                      manufacture large, heavy duty metal springs for the
                      agricultural equipment, mechanical equipment, and overhead
                      garage door industries. We are ISO 9001:2015 certified and
                      members of the Spring Manufacturers Institute (SMI).
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TheHeader",
  methods: {
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
      return paths.some((path) => {
        return this.$route.path.indexOf(path) === 0;
      });
    },
  },
};
</script>

<style scoped>
.navbar-default .navbar-nav li:not(.home-link) > a:not(.btn).active {
  color: #fff;
  background-color: #cc0000;
}

.navbar-default .navbar-nav li > a:not(.btn).active .caret {
  color: #fff;
}

.navbar-default .navbar-nav li.open a:hover:not(.active),
.navbar-default .navbar-nav li.open a:focus:not(.active),
.navbar-default .navbar-nav li.open a:not(.active).dropdown-toggle {
  background-color: #fff;
  color: #cc0000 !important;
}

.navbar-default .navbar-nav li.open a:not(.active) .caret {
  color: #cc0000 !important;
}

.navbar-default .navbar-nav .dropdown-menu {
  background-color: #fff;
  border-top-color: #fff;
}

.navbar-default .navbar-nav .dropdown-menu li a:not(.btn).active:before {
  color: #fff;
}
</style>




// WEBPACK FOOTER //
// src/components/layout/TheHeader.vue